<template>
  <path pid="0" d="M13 3A10 10 0 003 13v7a3 3 0 003 3h1a3 3 0 003-3v-3a3 3 0 00-3-3H5v-1a8 8 0 018-8h.25A8 8 0 0121 13v1h-2a3 3 0 00-3 3v3a3 3 0 003 3h1a3 3 0 003-3v-7A10 10 0 0013 3zM7 16a1 1 0 011 1v3a1 1 0 01-1 1H6a1 1 0 01-1-1v-4zm14 4a1 1 0 01-1 1h-1a1 1 0 01-1-1v-3a1 1 0 011-1h2z"/>
</template>
